import cn from 'classnames';
import QR from 'react-qr-code';
import { Spinner } from '#assets/Spinner.tsx';
import { useMatchMedia } from '#hooks/useMatchMedia.ts';
import styles from './QRCode.module.css';

type Props = {
  value?: string;
  /**
   * Accessible name for the code, e.g. "QR code containing the enrollment link". Required rather
   * than optional because a QR code is content, not decoration: it encodes a route through the flow
   * that exists nowhere else on screen, so a user who cannot see it still has to be told it is there.
   */
  title: string;
  className?: string;
  small?: boolean;
};

export function QRCode({ value, title, small, className }: Props) {
  const isNarrowWindow = useMatchMedia('(max-width: 500px), (max-height: 660px)');
  const isSmall = small ?? isNarrowWindow;

  return (
    <div className={cn(styles.QRCode, className)} role="img" aria-label={title} aria-busy={!value}>
      {value ?
        <QR value={value} aria-hidden bgColor="transparent" size={isSmall ? 128 : 256} />
      : <div className={cn('center', styles.QRCode_placeholder, { [styles.QRCode_placeholder___small]: isSmall })}>
          <Spinner className={styles.QRCode_spinner} />
        </div>
      }
    </div>
  );
}
